import {UsersAndPermissionsDataDto} from "../../dtos";
import {Action} from "../actions/usersAndPermissionsActions";
import {ActionType} from "../actionTypes";

const initialState: UsersAndPermissionsDataDto = {
    loading: true,
    type: null,
    error: null,
    usersAndPermissions: []
}

const reducer = (state: UsersAndPermissionsDataDto = initialState, action: Action) => {

    switch(action.type)
    {
        //
        case ActionType.GET_USERS_AND_PERMISSIONS_DATA_START:
        case ActionType.SAVE_USER_AND_PERMISSIONS_DATA_START:
            return { ...state, error: null, loading: true, type: action.type };
        case ActionType.DELETE_USER_AND_PERMISSIONS_DATA_START:
            return { ...state, error: null, loading: false, type: action.type };
        case ActionType.GET_USERS_AND_PERMISSIONS_DATA_SUCCESS:
        case ActionType.DELETE_USER_AND_PERMISSIONS_DATA_SUCCESS:
        case ActionType.UPDATE_USER_AND_PERMISSIONS_DATA:
        case ActionType.SAVE_USER_AND_PERMISSIONS_DATA_SUCCESS:
            return {
                usersAndPermissions: action.payload,
                error: null,
                loading: false,
                type: action.type
            };
        case ActionType.GET_USERS_AND_PERMISSIONS_DATA_COMPLETE:
        case ActionType.DELETE_USER_AND_PERMISSIONS_DATA_COMPLETE:
        case ActionType.SAVE_USER_AND_PERMISSIONS_DATA_COMPLETE:
            return { ...state, error: null, loading: false, type: action.type};

        case ActionType.GET_USERS_AND_PERMISSIONS_DATA_ERROR:
        case ActionType.DELETE_USER_AND_PERMISSIONS_DATA_ERROR:
        case ActionType.SAVE_USER_AND_PERMISSIONS_DATA_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type };
        default:
            return state;
    }
}

export default reducer;